import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import GitHubIcon from "@mui/icons-material/GitHub";

interface ProjectContainerProps {
	name: string;
	label: string;
	description?: string;
	appUrl?: string;
	devUrl?: string;
}

const ProjectContainer: React.FC<ProjectContainerProps> = ({
	label,
	description,
	appUrl,
	devUrl,
}) => {
	return (
		<Card
			sx={{
				width: 280,
				height: 165,
				borderRadius: 3,
				boxShadow: 3,
				border: "1px solid rgba(0, 0, 0, 0.15)",
				backgroundColor: "white",
				p: 2,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				transition: "all 0.2s ease-in-out",
				"&:hover": {
					boxShadow: 6,
					// transform: "scale(1.02)",
					border: "0.5px solid #0082ac",
				},
			}}
		>
			<CardContent sx={{ flexGrow: 1 }}>
				<Typography
					variant="h6"
					fontWeight="bold"
					color="primary"
					gutterBottom
				>
					{label}
				</Typography>
				{description && (
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ mt: 1 }}
					>
						{description}
					</Typography>
				)}
			</CardContent>

			<CardActions
				sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
			>
				{appUrl && (
					<Button
						variant="contained"
						color="primary"
						href={appUrl}
						target="_blank"
						startIcon={<OpenInNewIcon />}
						sx={{ textTransform: "none", borderRadius: 2 }}
						size="small"
					>
						App
					</Button>
				)}
				{devUrl && (
					<Button
						variant="outlined"
						color="secondary"
						href={devUrl}
						target="_blank"
						startIcon={<GitHubIcon />}
						sx={{ textTransform: "none", borderRadius: 2 }}
						size="small"
					>
						GitHub
					</Button>
				)}
			</CardActions>
		</Card>
	);
};

export default ProjectContainer;
